import {useBasketStore} from './useStore'

export const useItemsUnavailable = () => {
  const {previouslyRemovedItems} = useBasketStore()
  return previouslyRemovedItems?.length > 0
}
